/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_TitleInputs */

const cs_gdpr_review_title = /** @type {(inputs: Gdpr_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrola uchování údajů`)
};

const en_gdpr_review_title = /** @type {(inputs: Gdpr_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retention review`)
};

/**
* | output |
* | --- |
* | "Retention review" |
*
* @param {Gdpr_Review_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_title = /** @type {((inputs?: Gdpr_Review_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_title(inputs)
	return cs_gdpr_review_title(inputs)
});